import { getSettingData } from "@/api/myPractice"
import { isObjEmpty } from "./helper";
const account = {
    namespaced: true,
    state: {
        old_whitelabel: {},
        old_blooddraw: { bloodDrawOptions: {} },
        old_concierge_blood_draw_options: '',
        is_show_concierge_blood_draw_options: '',
        infoURL: '/setting/getPNSSettingV2',
        postwhiteLabelURL: '/setting/setPNSSetting',
        postbloodDrawURL: '/setting/setPNSV2'
    },
    getters: {
    },
    mutations: {
        SET_OLD_BLOODDRAW(state, data) {
            state.old_blooddraw = data
        },

        SET_OLD_WHITELABEL(state, data) {
            state.old_whitelabel = data
        },

        SET_OLD_CONCIERGE_BLOOD_DRAW_OPTIONS(state, data) {
            state.old_concierge_blood_draw_options = data
        },

        SET_IS_SHOW_CONCIERGE_BLOOD_DRAW_OPTIONS(state, data) {
            state.is_show_concierge_blood_draw_options = data
        },

        SET_DEFAULT(state) {
            state.old_whitelabel = {}
            state.old_blooddraw = { bloodbloodDrawOptions: {} }
        }
    },
    actions: {
        async getSettingData({ state, commit }) {
            console.log("called")
            if (isObjEmpty(state.old_whitelabel)) {
                const res = await getSettingData(state.infoURL);
                if (res.data.pns) commit("SET_OLD_BLOODDRAW", res.data.pns);
                commit("SET_OLD_WHITELABEL", res.data.practice);
                commit("SET_OLD_CONCIERGE_BLOOD_DRAW_OPTIONS", res.data.personal.concierge_blood_draw_options)
                commit("SET_IS_SHOW_CONCIERGE_BLOOD_DRAW_OPTIONS", res.data.personal.is_show_concierge_blood_draw_options)
            }
        },

        setBlooddraw({ commit }, data) {
            commit("SET_OLD_BLOODDRAW", data)
        },
        setWhiteLabel({ commit }, data) {
            commit("SET_OLD_WHITELABEL", data)
        },
        setConciergeBloodDrawOptions({ commit }, data) {
            commit("SET_OLD_CONCIERGE_BLOOD_DRAW_OPTIONS", data)
        },

    },
}

export default account;